import { render, staticRenderFns } from "./activityPurchasess.vue?vue&type=template&id=bf617104"
import script from "./activityPurchasess.vue?vue&type=script&lang=js"
export * from "./activityPurchasess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports